import { FeatureToggleClientService } from 'feature-toggle-client';
import { ChannelsNames } from './Channels';
const Instagram = 'channel-instagram';
const MessengerMfe = 'new-channel-messenger-mfe';
const HideWhatsAppEmbedSignup = 'hide-whatsapp-embed-signup';
const UsingConfigurationsService = 'channels-using-configurations-service-';
const UseWhatsAppOnPremise = 'whatsapp-is-on-premise';
const UseEntryPointsPrivateReplies = 'is-entry-points-private-replies-enabled';
const EnableEmailRegistrationInstagram = 'enable-email-registration-instagram';
const ChannelBlipChatShowAuthenticatedMediasConfiguration = 'blip-chat-show-authenticated-medias-configuration';
const ChannelBlipChatShowAudioRecordConfiguration = 'blip-chat-show-audio-record-configuration';
const ChannelBlipChatShowOpenImageInFrameConfiguration = 'blip-chat-show-open-image-in-frame';
const WhatsAppSkipValidadeTicket = 'whatsapp-skip-validate-ticket';
const WhatsAppHideStatusCompanyInformation = 'whatsapp-hide-status-company-information';
const WhatsAppCoexistenceEnabled = 'whatsapp-coexistence-enabled';
const WhatsAppMfeEnabled = 'whatsapp-mfe-enabled';
const ShowWhatsappAuthenticatedMedia = 'show-whatsapp-authenticated-media';
const UseConfigurationsDomainOnChannelOperationsGet = 'use-configurations-domain-on-channels-operations-get';
const UseConfigurationsDomainOnChannelOperationsSet = 'use-configurations-domain-on-channels-operations-set';
const UseGatewayConfigurationsEndpoint = 'use-gateway-configurations-endpoint';
export class ChannelsFeatures {
    static checkFeatureToggle(featureToggleName, defaultValue = false) {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(featureToggleName, defaultValue);
    }
    static async isWhatsAppEmbedSignupDisable() {
        return await ChannelsFeatures.checkFeatureToggle(HideWhatsAppEmbedSignup, false);
    }
    static async isWhatsAppMfeEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(WhatsAppMfeEnabled, false);
    }
    static async isWhatsappAuthenticatedMediaEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(ShowWhatsappAuthenticatedMedia, false);
    }
    static async isWhatsAppSkipValidateTicketEnable() {
        return await ChannelsFeatures.checkFeatureToggle(WhatsAppSkipValidadeTicket, false);
    }
    static async isWhatsAppHideStatusInformationEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(WhatsAppHideStatusCompanyInformation, false);
    }
    static async isEmailRegistrationInstagramEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(EnableEmailRegistrationInstagram, false);
    }
    static isInstagramEnabled() {
        return ChannelsFeatures.checkFeatureToggle(Instagram);
    }
    static isMessengerMfeEnabled() {
        return ChannelsFeatures.checkFeatureToggle(MessengerMfe);
    }
    static isAuthenticatedMediaConfigurationEnabled() {
        return ChannelsFeatures.checkFeatureToggle(ChannelBlipChatShowAuthenticatedMediasConfiguration);
    }
    static isAudioRecordEnabled() {
        return ChannelsFeatures.checkFeatureToggle(ChannelBlipChatShowAudioRecordConfiguration);
    }
    static isOpenImageInFrameEnabled() {
        return ChannelsFeatures.checkFeatureToggle(ChannelBlipChatShowOpenImageInFrameConfiguration);
    }
    static isChannelUsingConfigurationsServiceEnabled(channelsNames) {
        return ChannelsFeatures.checkFeatureToggle(`${UsingConfigurationsService}${channelsNames}`);
    }
    static async getChannelsUsingConfigurationsService() {
        const channelsUsingConfigurationsServicePromises = Object.values(ChannelsNames)
            .map(async (channelName) => {
            if (await ChannelsFeatures.isChannelUsingConfigurationsServiceEnabled(channelName)) {
                return channelName;
            }
        });
        const channelsUsingConfigurationsService = await Promise.all(channelsUsingConfigurationsServicePromises);
        return channelsUsingConfigurationsService.filter(ft => ft !== undefined);
    }
    static async IsWhatsAppOnPremiseEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(UseWhatsAppOnPremise);
    }
    static async IsEntryPointsPrivateRepliesEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(UseEntryPointsPrivateReplies);
    }
    static async isWhatsAppCoexistenceEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(WhatsAppCoexistenceEnabled, false);
    }
    static async isConfigurationsDomainOnChannelsOperationsGetEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(UseConfigurationsDomainOnChannelOperationsGet, false);
    }
    static async isConfigurationsDomainOnChannelsOperationsSetEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(UseConfigurationsDomainOnChannelOperationsSet, false);
    }
    static async isGatewayConfigurationsFromNewEndpointEnabled() {
        return await ChannelsFeatures.checkFeatureToggle(UseGatewayConfigurationsEndpoint, false);
    }
}
